import React from 'react';
import { Section } from './ui/Section';
export function Benefits() {
  const pillars = [{
    icon: '💃',
    title: '6 Tomos de Élite',
    subtitle: 'Técnica',
    desc: 'Psicología, técnica, braceo, ritmo, estilos y gestión. Todo el conocimiento que necesitas en un solo lugar.'
  }, {
    icon: '🧠',
    title: 'Método Progresivo',
    subtitle: 'Pedagogía',
    desc: 'De la primera clase a la actuación de fin de curso. Con el sistema correcto cualquier alumna puede bailar en 3 semanas.'
  }, {
    icon: '🛡️',
    title: 'Sistema Anti-Bajas',
    subtitle: 'Retención',
    desc: 'Protocolos específicos para los 3 momentos críticos de abandono. Scripts de WhatsApp listos para usar.'
  }, {
    icon: '📈',
    title: 'Plan de Negocio',
    subtitle: 'Negocio',
    desc: 'Cómo calcular tu precio, gestionar tu academia como empresa y escalar tus ingresos más allá de las clases.'
  }];
  return <Section variant="alt" data-id="element-18">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-19">
        🎁 Todo lo que una Instructora Necesita en un Único Lugar
      </h2>
      <p className="text-center text-brand-text mb-8 font-body" data-id="element-20">
        Cuatro pilares estratégicos diseñados para que dejes de improvisar y
        enseñes con confianza.
      </p>

      <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-21">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto mb-6" data-id="element-22">
        <table className="w-full min-w-[600px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-23">
          <thead data-id="element-24">
            <tr className="bg-brand-bgAlt border-b border-brand-border" data-id="element-25">
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-26">
                Pilar
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-27">
                Icono
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-28">
                Nombre
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-29">
                Descripción
              </th>
            </tr>
          </thead>
          <tbody data-id="element-30">
            {pillars.map((pillar, i) => <tr key={i} className="hover:bg-brand-bgAlt transition-colors border-b border-brand-border last:border-0" data-id="element-31">
                <td className="p-3 text-brand-title font-heading font-semibold" data-id="element-32">
                  {pillar.subtitle}
                </td>
                <td className="p-3 text-3xl" data-id="element-33">{pillar.icon}</td>
                <td className="p-3 text-brand-subtitle font-heading font-bold" data-id="element-34">
                  {pillar.title}
                </td>
                <td className="p-3 text-brand-text font-body text-sm" data-id="element-35">
                  {pillar.desc}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="text-center text-brand-text text-sm font-body" data-id="element-36">
        + Acceso inmediato a todos los recursos en formato PDF, listos para
        imprimir o usar desde tu móvil antes de entrar a clase.
      </p>
    </Section>;
}